<template>
	<div class="page">
		<top-header></top-header>
		<b-container fluid >
		<b-row class="mb-3">	
			<top-nevleft></top-nevleft>
			
		 <b-col class="p-0">
		 <!-- <b-row class="breadcrumbrow mt-1 m-0">				
			<b-col>
			 <h5 class="text-center">Admin Dashboard</h5>
			</b-col>				
		 </b-row> -->
		<!-- <b-container fluid>
			<b-row class="mt-3 mb-2">
				<b-col class="col-md-6 col-sm-6 col-xs-6 text-left">
					<h3>Manage Orders</h3>
				</b-col>
				<b-col class="col-md-6 col-sm-6 col-xs-6 text-right">
					<b-button variant="dark" pill  @click="generateStock()"><b-icon class="mr-2" icon="download" aria-hidden="true"></b-icon>Generate Stock JSON</b-button>
				</b-col>
			</b-row>
		</b-container> -->
		<b-container fluid class="mt-3 mb-2">
			<b-row>
				<b-col class="col-md-12 col-sm-12 col-xs-12">
					<div class="container-box">
						<b-row class="mt-4 px-3">
							<b-col lg="6" class="text-left">
								<span class="mr-2">Show</span>
								<b-form-select v-model="perPage" id="perPageSelect" :options="pageOptions" size="sm" class="w-25">
								</b-form-select>
								<span class="ml-2">entries</span>
							</b-col>
							<b-col lg="4" offset-md="2">
								<b-form-group label="Filter" label-cols-sm="3" label-align-sm="right" label-size="sm" label-for="filterInput" class="mb-0">
									<b-input-group size="sm">
										<b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search">
										</b-form-input>
										<b-input-group-append>
											<b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
										</b-input-group-append>
									</b-input-group>
								</b-form-group>
							</b-col>
						</b-row>
						<b-row class="px-3 pt-3">
							<b-col lg="12">
								<b-table show-empty sticky-header small striped outlined id="my-table" stacked="md" :items="records" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :filterIncludedFields="filterOn" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered">
								
									<template v-slot:cell(seller_name)="row">
										<span> {{row.value}} <whatappchat-user :phone="row.item.seller_phone" listtype="mark"></whatappchat-user></span> 
									</template>
								
									<template v-slot:cell(status)="row">
										<b-badge pill variant="warning" v-if="row.value == 0">NEW</b-badge>
										<b-badge pill variant="success" v-else>IN PROCESS</b-badge>
									</template>
									<!--<template v-slot:cell(customer_name)="row">
										<span>{{$root.currency($root.tofixed(row.value, 2))}}</span>
									</template>-->
									<template v-slot:cell(price)="row">
										<span>{{$root.currency()+$root.tofixed(row.value, 2)}}</span>
									</template>
									<template v-slot:cell(total_items)="row">
										<span>{{$root.tofixed(row.value, 2)}}</span>
									</template>
									<template v-slot:cell(wallet_balance_applied)="row">
										<span v-if="row.value==0">{{$root.currency()+$root.tofixed(row.item.price, 2)}}</span>										
										<span v-else-if="row.value<row.item.price">{{$root.currency()+$root.tofixed(row.item.price-row.value, 2)}} + {{$root.currency()+$root.tofixed(row.value, 2)}}</span>
										<span v-else>{{$root.currency()+$root.tofixed(row.value, 2)}}</span>
										
										
										
									</template>
									<template v-slot:cell(commission)="row">
										<span>{{$root.currency()+$root.tofixed(row.value, 2)}} ({{row.item.commission_rate}}%)</span>
									</template>
									<template v-slot:cell(created_at)="row">
										<span>{{$moment(row.value).format('DD-MM-YYYY HH:mm:ss')}}</span>
									</template>
                                    <template v-slot:cell(image)="row">
                                        <b-img v-bind="thumbnailProps" rounded alt="" :src="$root.MEDIAPATH+$session.get('user_info').uniq_id+'/stock/img/'+row.item.design_id+'.png'">{{row}}</b-img>
                                    </template>
									<template v-slot:cell(actions)="row">
										<b-button pill variant="primary" class="mr-1" @click="showUpdateModal(row.item, row.index, $event.target)" size="sm">View</b-button>
										<!--<b-button pill variant="danger" class="mr-1" @click="showDeleteModal(row.item)" size="sm">Delete</b-button>-->
									</template>
								</b-table>
							</b-col>
						</b-row>
						<b-row class="px-3">
							<b-col lg="6" class="text-left">
								<span class="mr-2">Showing {{currentPage}} to {{(perPage>records.length)?records.length:perPage}} of {{records.length}} entries</span>
							</b-col>
							<b-col lg="3" offset-md="3">
								<b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" align="right" size="sm" prev-text="Prev" next-text="Next" first-number last-number></b-pagination>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>

			
			<b-modal id="my-model" title="Order Detail" size="xl" ok-only @hidden="resetSelectedItem" @ok="modalSubmit">
				<form ref="form" @submit.stop.prevent="handleSubmit">
					<b-container fluid>
						<b-row class="mb-1">
                            <b-col cols="4">
                                <b-table-simple hover small caption-top responsive>
                                    <!--<caption></caption>-->
                                    <b-thead head-variant="light">
                                        <b-tr>
                                            <b-th colspan="2">Ordered By </b-th>
                                        </b-tr>
                                    </b-thead>
                                    <b-tbody>
                                        <b-tr>
                                            <b-th>Name</b-th>
                                            <b-th class="text-right">{{selectedItem.customer_data.billing.firstname}} {{selectedItem.customer_data.billing.lastname}}</b-th>
                                        </b-tr>
                                        <b-tr>
                                            <b-th>Email</b-th>
                                            <b-th class="text-right">{{selectedItem.customer_data.billing.email}}</b-th>
                                        </b-tr>
                                        <b-tr>
                                            <b-th>Phone</b-th>
                                            <b-th class="text-right">{{selectedItem.customer_data.billing.phone}}</b-th>
                                        </b-tr>
                                        <b-tr>
                                            <b-th>City</b-th>
                                            <b-th class="text-right">{{selectedItem.customer_data.billing.city}}</b-th>
                                        </b-tr>
										<b-tr>
                                            <b-th>State</b-th>
                                            <b-th class="text-right">{{selectedItem.customer_data.billing.state}}</b-th>
                                        </b-tr>
                                        <b-tr>
                                            <b-th>Postcode</b-th>
                                            <b-th class="text-right">{{selectedItem.customer_data.billing.pincode}}</b-th>
                                        </b-tr>
										<b-tr>
                                            <b-th>Country</b-th>
                                            <b-th class="text-right">{{selectedItem.customer_data.billing.country}}</b-th>
                                        </b-tr>
                                   </b-tbody>
<!--<b-tfoot><b-tr><b-td colspan="7" variant="secondary" class="text-right"> Total Rows: <b>5</b></b-td></b-tr></b-tfoot>-->
                                </b-table-simple>
                                <!--<b-img class="w-100" rounded alt="" :src="$root.MEDIAPATH+$session.get('user_info').uniq_id+'/stock/img/'+selectedItem.design_id+'.png'"></b-img>-->
                            </b-col>
							<b-col cols="4">
                                	<b-table-simple hover small caption-top responsive>
										<b-thead head-variant="light">
											<b-tr>
												<b-th colspan="2">SOLD BY:</b-th>
											</b-tr>
										</b-thead>
											<b-tbody>
												<b-tr>
													<b-th>Business_name</b-th>
													<b-th class="text-right">{{businessDetails.business_name}}</b-th>
												</b-tr> 
												<b-tr>
													<b-th>Address</b-th>
													<b-th class="text-right">{{businessDetails.communication_address}}</b-th>
												</b-tr>
												<b-tr>
													<b-th>Ph:</b-th>
													<b-th class="text-right">{{businessDetails.phone}}</b-th>
												</b-tr>
												<b-tr>
													<b-th>GSTIN No.</b-th>
													<b-th class="text-right">{{businessDetails.gst}}</b-th>
												</b-tr>
												<b-tr>
													<b-th>Email</b-th>
													<b-th class="text-right">{{businessDetails.email}}</b-th>
												</b-tr>
												
												
												
										   </b-tbody>
									</b-table-simple>

                            </b-col>
							<b-col cols="4">
								<b-table-simple hover small caption-top responsive>
                                    <b-thead head-variant="light">
                                        <b-tr>
                                            <b-th colspan="2">Order Information</b-th>
                                        </b-tr>
                                    </b-thead>
										<b-tbody>
											<b-tr>
												<b-th>Order Id</b-th>
												<b-th class="text-right">{{selectedItem.uuid}}</b-th>
											</b-tr> 
											<b-tr>
												<b-th>Date</b-th>
												<b-th class="text-right">{{$moment(selectedItem.created_at).format('DD-MM-YYYY HH:mm:ss')}}</b-th>
											</b-tr>
											<b-tr>
												<b-th>Total Items</b-th>
												<b-th class="text-right">{{selectedItem.total_items}} Qty</b-th>
											</b-tr>
											<b-tr>
												<b-th>Price</b-th>
												<b-th class="text-right">{{selectedItem.price}}</b-th>
											</b-tr>
											<b-tr>
												<b-th>Discount Applied</b-th>
												<b-th class="text-right">{{selectedItem.discount}}</b-th>
											</b-tr>
											<b-tr>
												<b-th>Status</b-th>
												<b-th class="text-right"><b-badge pill :variant="$root.filterorderstatus(selectedItem.order_status)[0].color">{{$root.filterorderstatus(selectedItem.order_status)[0].label}}</b-badge></b-th>
											</b-tr>
											<b-tr>
												<b-th>Payment Status</b-th>
												<b-th class="text-right"><b-badge pill :variant="$root.filterpaymentstatus(selectedItem.payment_status)[0].color">{{$root.filterpaymentstatus(selectedItem.payment_status)[0].label}}</b-badge></b-th>
											</b-tr>
											<b-tr>
												<b-th>Delivery Status</b-th>
												<b-th class="text-right" v-if="selectedItem.delivery_status == 0"><b-badge pill variant="danger">Pending</b-badge></b-th>
												<b-th class="text-right"><b-badge pill :variant="$root.filterdeliverystatus(selectedItem.delivery_status)[0].color">{{$root.filterdeliverystatus(selectedItem.delivery_status)[0].label}}</b-badge></b-th>
											</b-tr>
									   </b-tbody>
                                </b-table-simple>
							</b-col>
						</b-row>
                        <b-row class="mb-1">
                            <b-col>
									<b-table :fields="orderfields" :items="selectedItem.order_items" outlined small >
									
										<template v-slot:cell(title)="row">
											<ul class="p-0"> 
												<li>
												{{row.item.title}}
												</li>
												<li v-if="row.item.product_type==2">
												 <div class="p-0 m-0" v-for="(item, index) in row.item.variation_attributes" :key="item">
														<span class="text-capitalize "><!-- font-weight-bold -->  {{item}}: </span>
														<span class="text-uppercase">{{row.item.variations_selected[index]}}</span>
														
													</div>
												
												</li>
											</ul>
											<!-- <span  v-if="row.item.special_price>0 && row.item.special_price!=null">{{$root.currency()+$root.tofixed(row.item.special_price, 2)}} 
											<del>{{$root.currency()+$root.tofixed(row.item.price, 2)}}</del></span> 
											<span v-else> 
											{{$root.currency()+$root.tofixed(row.item.price, 2)}}</span> -->
											
										</template>
									
									
										<template v-slot:cell(price)="row">
											
											<span  v-if="row.item.special_price>0 && row.item.special_price!=null">{{$root.currency()+$root.tofixed(row.item.special_price, 2)}} 
											<del>{{$root.currency()+$root.tofixed(row.item.price, 2)}}</del></span> 
											<span v-else> 
											{{$root.currency()+$root.tofixed(row.item.price, 2)}}</span>
											
										</template>
										<template v-slot:cell(commission)="row">                                       
											<!-- <span>{{Number(row.value) + 5}}%</span> -->
										   
											 <ul class="p-0"> 
												<li>
													Admin Comm. : 5%
												</li>
												<li>
													Advisor Comm. : {{Number(row.value)}}%
												
												</li>
											</ul>
											
										</template>
										<template v-slot:cell(total_price)="row">
											<span v-if="row.item.special_price>0 && row.item.special_price!=null">{{$root.currency()+$root.tofixed((row.item.special_price * row.item.qty - (row.item.special_price * (Number(row.item.commission) + 5)/100) * row.item.qty), 2)}}</span>
											<span v-else >{{$root.currency()+$root.tofixed((row.item.price * row.item.qty - (row.item.price * (Number(row.item.commission) + 5)/100) * row.item.qty), 2)}}</span>
										</template>
									</b-table>
									 <b-row class="mb-0">
                                    <b-col class="text-right font-sm">
                                        <span>Commission: {{$root.currency()+$root.tofixed(selectedItem.commission, 2)}}</span>
                                    </b-col>
                                </b-row>
                                <b-row class="mb-3">
                                     <b-col class="text-right font-sm">
                                        <span>Paid Amount: {{$root.currency()+$root.tofixed(selectedItem.price - selectedItem.commission, 2)}} </span>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
						<b-row>
						<b-col>
							<!-- Order ID --->
							<!--{{JSON.stringify(selectedItem)}} -->
							
							<!-- {{selectedItem.shipment_track_activities}}
							{{shipment_track_activities}}
							{{selectedItem.uuid}} 
							{{selectedItem.shipment_status}} -->
							
						<shipped-tracking v-if="shippingBy_selected=='shiprocket'" :awb_code="awb_code_selected" :shipment_id="shipment_id_selected" :shipment_order_id="shipment_order_id" :shippingBy="shippingBy_selected" :srToken="srToken" :orderId="selectedItem.uuid" :shipmenttrackactivities="shipment_track_activities" :currentshipment_status="Number(selectedItem.shipment_status)"></shipped-tracking>
						</b-col>
						</b-row>
					</b-container>
				</form>
				<template v-slot:modal-footer="{ ok, close }">
					<b-button size="sm" variant="danger" @click="close()">Cancel</b-button>
				</template>
			</b-modal>
		
		</b-container>
		<transition name="fade">
			<b-row v-if="loading" class="loading" style="position: absolute; top:0px; left:0px; right:0px; bottom:0px; z-index: 1000; background-color: rgba(0,0,0,0.4);" align-v="center" align-h="center">
				<b-spinner label="Busy" variant="light"></b-spinner>
			</b-row>
		</transition>
		<top-footer></top-footer>
	</b-col>
	</b-row>
		
	</b-container>
	</div>
	
</template>
<script>
//import Header from "@/components/admin/Header.vue";
import Header from "@/components/header.vue";
import Footer from "@/components/footer-admin.vue";
import TreeviewPage from "@/components/admin/nevleft.vue";
import Shippedtracking from "@/components/shipped-tracking.vue"; 
import Whatappchatuser from "@/components/whatapp-chat-ordre.vue"; 
export default {
	name: 'Devices',
	components: {
		"top-header": Header,
		"top-footer": Footer,
		"top-nevleft": TreeviewPage,
		"shipped-tracking": Shippedtracking,
		"whatappchat-user": Whatappchatuser,
	},
	mounted(){
		var self = this;
		Object.assign(self.selectedItem, self.emptyItem);
		this.initload();
	},
	data() {
		return{
            loading: true, 
            thumbnailProps: { blank: false, width: 60, height: 60, class: 'm1' },
            regularProps: { blank: false, width: 200, height: 200, class: 'm1' },
            recordUrl: this.$root.WEBAPI+'secureapi/order-record',
			updateUrl: this.$root.WEBAPI+'secureapi/order-update',
			deleteUrl: this.$root.WEBAPI+'secureapi/order-delete',
			businessDetailUrl: this.$root.NEWAPIURL+'profileapi/load-business-sellerid',
            records: [],
            category_options: [],
            cut_options: [],
            color_options: [],
			breadcrumb: [
				{
					text: 'Home',
					href: '/'
				},
				{
					text: 'Dyo Designs',
					active: true
				}
			],
			fields: [
				//{ key: 'id', label: 'ID'},
				{ key: 'uuid', label: ' Order ID'},
				{ key: 'customer_name', label: 'Customer',
					formatter: (value, key, item) => { 
						//console.log(JSON.stringify(item));
						if(item.customer_name == null){
							return item.customer_data.billing.firstname+' '+item.customer_data.billing.lastname;
						}else{
							return item.customer_name;
						}
					} 
				},
				{ key: 'agent_name', label: 'Agent',
					formatter: (value, key, item) => {
						if(item.referer_id == 0){
							return '-n/a-';
						}else{
							return item.agent_name;
						}
					}
				},
				{ key: 'seller_name', label: 'Seller',
					formatter: (value, key, item) => {
						if(item.seller_name == null){
							return '-Unnamed Shop-';
						}else{
							return item.seller_name;
						}
					}
				},
				{ key: 'total_items', label: 'Total Qty' },
                { key: 'price', label: 'Price' },
                { key: 'discount', label: 'Discount' },
                { key: 'wallet_balance_applied', label: 'Amount Mode' },
				{ key: 'payment_mode', label: 'Payment Mode' },
                { key: 'order_status', label: 'Status' },
				{ key: 'payment_status', label: 'Payment' },
				{ key: 'commission', label: 'Commission' },
				{ key: 'created_at', label: 'Order Date' },
				{ key: 'actions', label: 'Actions', 'extra': 1 }
            ],
            itemfields: [
                { key: 'design_id', label: 'Design ID'},
                { key: 'title', label: 'Name'},
                { key: 'image_front', label: 'Front'},
                { key: 'image_back', label: 'Back'}
            ],
            orderfields: [
                { key: 'title', label: 'Name'},
                { key: 'sku', label: 'SKU', class: 'text-right'},
                { key: 'price', label: 'Price', class: 'text-center'},
                { key: 'qty', label: 'Qty', class: 'text-center'},
				{ key: 'commission', label: 'Comm.', class: 'text-center'},
                { key: 'total_price', label: 'Total Price', class:'text-right'},
            ],
            artworkfields: [
                { key: 'label', label: 'Name'},
                { key: 'color', label: 'Color', class: 'text-right'},
            ],
			totalRows: 1,
			currentPage: 1,
			pageOptions: [10, 20, 50, 100],
			perPage: 10,
			sortBy: '',
			sortDesc: false,
			sortDirection: 'asc',
			filter: null,
			filterOn: [],
			selectedItem: {customer_data:{'billing':{}, 'shipping':{}}},
			businessDetails:{
				business_name:'',
				business_logo:'',
				pan:'',
				gst:'',
				office_address:'',
				communication_address:'',
				brandas:'',
			},
			srToken:'',
			shippingBy_selected:'',
			awb_code_selected:'',
			shipment_id_selected:'',
			shipment_order_id:'',
			shipment_track_activities:[],
			
		};
	},
	methods: {
		getColorName(color){
			var selectedcolor = '';
			for(var i = 0; i<this.color_options.length; i++){
				if('#'+this.color_options[i].hexcode == color){
					selectedcolor = this.color_options[i];
					break;
				}
			}
			return '<span style="vertical-align:top">'+selectedcolor.title+"</span><div style='background-color:"+color+"; width:20px; height:20px; display:inline-block; margin-left:10px;'></div>";
		},
        convertToArray(obj){
            var arr = [];
           // console.log(obj);
            for (const [key, value] of Object.entries(obj)) {
                //console.log(`${key}: ${value}`);
                console.log(key);
                var o = {};
                o.label = value.label;
                o.color = value.color;
                arr.push(o);
            }
            return arr;
        },
		showAddModal(){
			this.selectedItem = Object.assign({}, this.emptyItem);
			this.$root.$emit('bv::show::modal', 'my-model');
		},
		showUpdateModal(item, index, button) {
			var self =this;
			self.selectedItem = Object.assign({}, item);
			
			//console.log('item.shipping_data_sr:'+item.shipping_data_sr);
			if(item.shipping_data_sr!=''){
				var sRshippingdata = item.shipping_data_sr;
				var sRshippingdataObj =  JSON.parse(sRshippingdata);
				var payload =	sRshippingdataObj.payload;
				self.awb_code_selected = payload.awb_code;
				self.shipment_id_selected = payload.shipment_id;
				self.shipment_order_id = payload.order_id;
				self.shippingBy_selected = 'shiprocket';
			}
			
			if(item.shipment_track_activities!=''){
			self.shipment_track_activities = JSON.parse(item.shipment_track_activities);
			}

			
			
			/* ============================ Business Detail ========================= */
			self.axios.post(self.businessDetailUrl, {
				accesskey: self.$session.get('access_key'),
				user_id: item.seller_id,
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					
					var tmp = response.data.result;
					if(tmp!=null){
					self.businessDetails = Object.assign({}, tmp);
					}
					
					
				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
				//setTimeout(self.initload, 1000*30);
			})
			.catch(function (error) {
				alert(error);
			});
			
			
			self.$root.$emit('bv::show::modal', 'my-model', button);
		},
		showCsvModal(item){
			var self = this;
			this.$bvModal.msgBoxConfirm('Please confirm that you want to generate product csv!.', {
				title: 'Please Confirm',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'success',
				okTitle: 'YES',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if(value == true){
					self.axios.post(self.csvgenUrl, {
						accesskey: self.$session.get('access_key'),
						product_id: item.product_id
					})
					.then(function (response) {
						if(response.data.error == 0 || response.data.error == '0'){

							self.$bvToast.toast(response.data.message, {
								title: 'Delete',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'warning',
								solid: true,
								appendToast: true
							});
							
							
						}
						
					})
					.catch(function (error) {
						alert(error);
					});
				}else{
					//alert('no '+item.id);
				}
			})
			.catch(err => {
				// An error occurred
				console.log(err);
			})
		},
		showDeleteModal(item){
			var self = this;
			this.$bvModal.msgBoxConfirm('Please confirm that you want to delete order!.', {
				title: 'Please Confirm',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'YES',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if(value == true){
					self.axios.post(self.deleteUrl, {
						accesskey: self.$session.get('access_key'),
						delete_id: item.design_id
					})
					.then(function (response) {
						if(response.data.error == 0 || response.data.error == '0'){
							self.$bvToast.toast(response.data.message, {
								title: 'Delete',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'warning',
								solid: true,
								appendToast: true
							});
							self.initload();
						}
						
					})
					.catch(function (error) {
						alert(error);
					});
				}else{
					//alert('no '+item.id);
				}
			})
			.catch(err => {
				// An error occurred
				console.log(err);
			})
		},
		modalSubmit(bvModalEvt){
			var self = this;
			self.loading = true;
			bvModalEvt.preventDefault();
			var submitUrl = self.updateUrl;

            
			self.axios.post(submitUrl, {
				accesskey: self.$session.get('access_key'),
				data: self.selectedItem
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.$bvModal.hide('my-model');
					self.$bvToast.toast(response.data.message, {
						title: 'Status',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'warning',
						solid: true,
						appendToast: true
					});
					self.initload();
				}
				
			})
			.catch(function (error) {
				alert(error);
			});
		},
		
		

		resetSelectedItem(){
			//var self = this;
			//self.selectedItem = Object.assign({}, self.emptyItem);
		},
		initload(){
			var self = this;
			
			self.axios.post(self.recordUrl, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					var _records = response.data.result.records;
					
                    _records.forEach(function(field){
                        field.order_items = JSON.parse(field.order_items);
                        field.customer_data = JSON.parse(field.customer_data);
                    });
                    
                    self.records = _records;
					self.color_options = response.data.result.colors;
					
					self.loading = false;
					self.totalRows = self.records.length;
				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
				//setTimeout(self.initload, 1000*30);
			})
			.catch(function (error) {
				alert(error);
			});
			//alert('login '+self.email+" "+self.password);
			
			/* ---------- SR Token generate -------- */
			if(self.srToken==''){
				var shipRocketUrl='https://apiv2.shiprocket.in/v1/external/auth/login';
				self.axios.post(shipRocketUrl, {
					email: "mahato@alluraa.com",
					password: "4ChmH5nKGnPigjpkV%6H43ZujRFRmPcX"
				})
				.then(function (response) {
					//console.log(response);
					var objResp = response.data;
					self.srToken = objResp.token;
					
					//console.log('MyToken'+self.srToken);

					

				})
				.catch(function (error) {
					alert(error);
				});
			}
			/* ---------- E N D SR -------- */
			
		},
		/*filtercategory(records){
			var filterarr = new Array();
			records.forEach(function(row){
				var dataarr = new Array();
				self.fields.forEach(function(field){
					if(field.key != 'extra'){
						dataarr.push(row[field.key]);
					}
				});
				finalarr.push(dataarr);
			});
		},*/
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
        },
        generateStock(){
            var self = this;
			
			self.axios.post(self.genstockUrl, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.$bvToast.toast(response.data.message, {
						title: 'Status',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'warning',
						solid: true,
						appendToast: true
					});
				}
			})
			.catch(function (error) {
				alert(error);
			});
		},
		downloadSVG(item){
			//console.log(JSON.stringify(item));
			self.axios.post(self.artworkUrl, {
				accesskey: self.$session.get('access_key'),
				artworkid: item.artwork_id
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					//console.log(JSON.stringify(response.data.result.artwork));
					self.$bvToast.toast(response.data.message, {
						title: 'Status',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'warning',
						solid: true,
						appendToast: true
					});
				}
			})
			.catch(function (error) {
				alert(error);
			});
		}
	}
}
</script>
<style>
</style>